import { initializeApp } from "firebase/app";
import { getFirestore, enableIndexedDbPersistence } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAvf_ZCEMkBlpR2PUS7J910ccf8qjCDyn0",
  authDomain: "reading-log-d5d0d.firebaseapp.com",
  projectId: "reading-log-d5d0d",
  storageBucket: "reading-log-d5d0d.firebasestorage.app",
  messagingSenderId: "923951064641",
  appId: "1:923951064641:web:3b9ca2c9c0995b7f2088c0"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);

enableIndexedDbPersistence(db).catch((err) => {
  if (err.code === "failed-precondition") {
    console.warn("Firestore offline persistence failed — multiple tabs open.");
  } else if (err.code === "unimplemented") {
    console.warn("Firestore offline persistence not supported in this browser.");
  }
});
export default app;